/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Activity_Eta_MinutesInputs */



/**
* | output |
* | --- |
* | "~{count} min remaining" |
*
* @param {Activity_Eta_MinutesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const activity_eta_minutes = /** @type {((inputs: Activity_Eta_MinutesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Eta_MinutesInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`~${i?.count} Min. verbleibend`)
	return /** @type {LocalizedString} */ (`~${i?.count} min remaining`)
});